module.exports = __webpack_public_path__ + "img/en-home-button.0e0984f1.png";